import { Autocomplete, TextField } from '@mui/material';
import { forwardRef, useEffect, useState } from 'react';
import { getTiposCoberturaDenuncia } from '../../services/Busquedas/TiposCoberturas';

export const TipoCoberturaDenunciaSelector = forwardRef(
  ({ label, onChangeOption, error, required = false }, ref) => {
    const [optionList, setOptionList] = useState([]);

    useEffect(() => {
      const fetchOptionList = async () => {
        const fetchedOptions = await getTiposCoberturaDenuncia();
        setOptionList(fetchedOptions || []);
      };

      fetchOptionList();
    }, []);

    const handleChange = (newValue) => {
      if (onChangeOption) {
        onChangeOption(newValue);
      }
    };

    return (
      <Autocomplete
        disablePortal
        // value={value || null}
        isOptionEqualToValue={(option, value) => option?.idTipoCobertura === value?.idTipoCobertura}
        getOptionLabel={(option) => `${option?.descripcion || ''}`}
        options={optionList}
        onChange={(_, newValue) => handleChange(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label || 'Tipo de cobertura'}
            variant='standard'
            error={!!error}
            helperText={error ? error.message : ''}
            InputProps={{
              ...params.InputProps,
              endAdornment: <>{params.InputProps.endAdornment}</>,
            }}
            required={required}
          />
        )}
      />
    );
  },
);
